import { useRef, useEffect } from 'react';
// Ensure that an effect is only ever executed once in the component's lifecycle.
// It doesn't do unmount cleanup, so only use it for stuff that doesn't need that
// TODO: Remove this in favor of `useEffectOnce`
export function useEffectOnceOnMount(callback) {
    const hasExecuted = useRef(false);
    useEffect(()=>{
        if (hasExecuted.current) {
            return;
        }
        callback();
        hasExecuted.current = true;
    // since we only run once, it's pointless to keep a memo list
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
